export default __webpack_public_path__ + "static/media/MyriadPro-Light.1d169f60.otf";